<template>
	<div id="termsAndConditions">

	
	<div v-if="isMobile">
		<div class="display-flow">
			<div v-if="serverBusy" class="loading">
				<span class="loading-icon"></span>
				<span class="loading-message">{{ busyText }}</span>
			</div>
			<div class="btn-container">
				<button class="btn" v-if="tosContent && showAcceptAndContinue" @click="eventBus.emit('termsViewed')">{{ termsAndConditions.buttonText }}</button>
				<button class="btn" v-if="tosContent && !showAcceptAndContinue" @click="eventBus.emit('closeTos')">{{ languageStrings.close }}</button>
			</div>
			<div v-if="latestVersion.format?.includes('html')" v-html="tosContent"></div>
			<div class="wrap-text" v-else>
				<h1 class="white-text">{{ languageStrings.termsAndConditions }}</h1>
				<div class="white-text wrap-text">{{ tosContent }}</div>
			</div>
			<img v-if="latestVersion.format?.includes('image')" :src="tosContent" />
		</div>
	</div>
	<div v-else>
		<div class="termsAndConditions">
			<div v-if="serverBusy" class="loading">
				<span class="loading-icon"></span>
				<span class="loading-message">{{ busyText }}</span>
			</div>
			<div class="btn-container">
				<button class="btn" v-if="tosContent && showAcceptAndContinue" @click="eventBus.emit('termsViewed')">{{ termsAndConditions.buttonText }}</button>
				<button class="btn" v-if="tosContent && !showAcceptAndContinue" @click="eventBus.emit('closeTos')">{{ languageStrings.close }}</button>
			</div>
			<div v-if="latestVersion.format?.includes('html')" v-html="tosContent"></div>
			<div class="wrap-text" v-else>
				<h1 class="white-text">{{ languageStrings.termsAndConditions }}</h1>
				<div class="white-text wrap-text">{{ tosContent }}</div>
			</div>
			<img v-if="latestVersion.format?.includes('image')" :src="tosContent" />
		</div>
	</div>
	</div>
</template>

<script>
export default {
	name: "TermsAndConditions",
	props: {
		playerState: Object,
		languageStrings: Object,
		languageErrorStrings: Object,
		tosContent: String,
		latestVersion: Object,
		showAcceptAndContinue: Boolean,
		isMobile: Boolean
	},
	data() {
		return {
			termsAndConditions: require(`@/dependencies/terms-${this.countryCode}.json`),
			serverBusy: false,
			busyText: "",
			termsViewed: false,
		};
	},
	watch: {},
	created() {},
	mounted() {
		document.getElementById("termsAndConditions").focus();
	},
	methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.termsAndConditions {
	position: fixed;
	display: grid;
	/* align-items: center; */
	justify-content: center;
	padding: 30px 15px;
	top: 60px;
	left: 0;
	width: 100%;
	height: 100%;
	/* overflow: hidden auto; */
	background-color: rgb(0 0 0/75%);
	backdrop-filter: blur(8px);
	z-index: 9999;
	overflow-wrap: break-word;
}

.btn-container {
	margin: auto;
	display: flex;
}

.terms-container button {
	position: fixed;
	top: 15px;
	width: 20em;
}

.white-text {
	color: white;
}

.display-flow {
	display: block;
	position: fixed;
	/* align-items: center; */
	justify-content: center;
	/* padding: 30px 15px; */
	top: 60px;
	left: 0;
	width: 100%;
	height: 100%;
	overflow: hidden auto;
	background-color: rgb(0 0 0/75%);
	backdrop-filter: blur(8px);
	z-index: 9999;
}

.wrap-text {
	max-width: 99%;
	overflow-wrap: break-word;
	height: 100vh;
	word-break: break-all;
}

/* .terms-container {
	overflow: hidden auto;
} */

/* iOS specific CSS */
@supports (-webkit-touch-callout: none) {
	.termsAndConditions {
		padding-top: 30px;
	}
}

@media (min-width: 768px) {
	.termsAndConditions {
		/* width: 80%; */
		top: 0;
		/* left: 20%; */
	
	}
}
</style>
